import { Row } from "react-grid-system";
import { theme } from "../../../theme";
import LoadingSpinner from "../../atoms/LoadingSpinner";
import Body from "../../atoms/typography/Body";

export default function LoginScreen() {
  return (
    <div
      style={{
        backgroundColor: theme.colors.grey02,
        color: theme.colors.primary,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        flexDirection: "column",
      }}
    >
      <div>
        <Row justify="center">
          <LoadingSpinner />
        </Row>
        <Row justify="center">
          <Body>Loggar in...</Body>
        </Row>
      </div>
    </div>
  );
}
